import { useState } from "react";

import ConfirmationModal from "../common/ConfirmationModal";
import { useHistory } from "react-router-dom";
const DangerModal = ({ handleDelete }: { handleDelete: () => void }) => {
  const history = useHistory();
  const [modalVisible, setModalVisible] = useState<boolean>(false);

  const onModalClose = () => {
    setModalVisible(false);
  };

  const onHandleDanger = () => {
    handleDelete();
    history.push("/account/chooseupload");
    onModalClose();
  };
  return (
    <>
      {/* <Button
        onClick={() => onModalOpen()}
        variant="subtle"
        mb={30}
        leftIcon={<IoIosArrowBack size={18} />}
      >
        {t("backToSelection")}
      </Button> */}
      {modalVisible && (
        <ConfirmationModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          onDanger={onHandleDanger}
          onSuccess={() => onModalClose()}
          title={"danger"}
          successButtonName={"stayOnSide"}
          dangerButtonName={"deleteFiles"}
        />
      )}
    </>
  );
};

export default DangerModal;
